// Services offered by Unity Health Centre.
// Shape mirrors the future backend model (Service). Replace content with client-approved text.
const services = [
  {
    id: 1,
    slug: "psychiatric-consultation-and-treatment",
    icon: "icon-head",
    img: "/assets/images/services/1.jpg",
    title: "Psychiatric Consultation & Treatment",
    shortDesc: "Accurate diagnosis, medication management and long-term stabilization by experienced psychiatrists.",
    desc: "Psychiatric consultation and treatment at Unity Health Centre focus on accurate diagnosis, medical management, and long-term stabilization of mental health conditions. Our psychiatrists provide personalized treatment plans based on clinical assessment and patient needs.",
    video: "https://www.youtube.com/watch?v=nrJtHemSPW4",
    duration: "Consultation: 30–45 minutes · Follow-up as advised",
    conditions: [
      "Major Depressive Disorder",
      "Anxiety & Panic Disorders",
      "Bipolar Disorder",
      "Schizophrenia & Psychotic Disorders",
    ],
    whatToExpect: [
      "Detailed history taking with the patient and family",
      "Mental status examination by a psychiatrist",
      "Screening tools and psychological tests when needed",
      "Clear diagnosis explained in simple language",
      "Personalized medication and therapy plan",
      "Scheduled follow-ups to track progress",
    ],
    coreValues: {
      title: "Our Core Values",
      desc: "We believe in compassionate, ethical, and evidence-based psychiatric care that prioritizes patient dignity, confidentiality, and long-term recovery.",
    },
    features: [
      {
        icon: "icon-heart",
        title: "Medical Check Ups",
        desc: "Comprehensive psychiatric evaluations and regular follow-ups.",
      },
      {
        icon: "icon-doctor",
        title: "Medical Treatment",
        desc: "Personalized medication management and therapy plans.",
      },
      {
        icon: "icon-call3",
        title: "Emergency Help 24/7",
        desc: "Immediate psychiatric support during crisis situations.",
      },
      {
        icon: "icon-drugs",
        title: "Research Professionals",
        desc: "Treatment guided by the latest psychiatric research.",
      },
    ],
    relatedServiceIds: [3, 4, 5],
    order: 1,
  },
  {
    id: 2,
    slug: "drug-addiction-treatment-and-rehabilitation",
    icon: "icon-heart",
    img: "/assets/images/services/2.jpg",
    title: "Drug Addiction Treatment & Rehabilitation",
    shortDesc: "Medically supervised detox, structured rehabilitation and relapse prevention for lasting recovery.",
    desc: "Unity Health Centre offers structured and ethical drug addiction treatment and rehabilitation programs designed to support detoxification, recovery, relapse prevention, and reintegration into society.",
    video: "https://www.youtube.com/watch?v=nrJtHemSPW4",
    duration: "Typical programme: 30–90 days (inpatient)",
    conditions: [
      "Alcohol Addiction",
      "Yaba & Methamphetamine Addiction",
      "Cannabis Dependency",
      "Prescription Drug Abuse",
    ],
    whatToExpect: [
      "Addiction assessment and physical health check",
      "Medically supervised detoxification",
      "Withdrawal management with 24/7 nursing",
      "Individual and group counseling",
      "Family involvement and education",
      "Relapse prevention and aftercare plan",
    ],
    coreValues: {
      title: "Our Core Values",
      desc: "We promote recovery through respect, non-judgmental care, and long-term behavioral change.",
    },
    features: [
      {
        icon: "icon-heart",
        title: "Safe Detox Programs",
        desc: "Medically supervised detoxification for substance dependence.",
      },
      {
        icon: "icon-doctor",
        title: "Rehabilitation Therapy",
        desc: "Structured inpatient and outpatient rehabilitation programs.",
      },
      {
        icon: "icon-call3",
        title: "Emergency Support",
        desc: "24/7 medical and psychological support during recovery.",
      },
      {
        icon: "icon-drugs",
        title: "Relapse Prevention",
        desc: "Long-term strategies to prevent relapse and sustain recovery.",
      },
    ],
    relatedServiceIds: [4, 5, 6],
    order: 2,
  },
  {
    id: 3,
    slug: "psychological-counseling-and-psychotherapy",
    icon: "icon-microscope",
    img: "/assets/images/services/3.jpg",
    title: "Psychological Counseling & Psychotherapy",
    shortDesc: "Confidential, evidence-based therapy such as CBT for emotional, behavioral and relationship problems.",
    desc: "Our psychological counseling services provide a safe, confidential, and non-judgmental environment for individuals facing emotional, behavioral, and psychological challenges.",
    video: "https://www.youtube.com/watch?v=nrJtHemSPW4",
    duration: "Session: 45–60 minutes · Usually 6–12 sessions",
    conditions: [
      "Cognitive Behavioral Therapy (CBT)",
      "Dialectical Behavior Therapy (DBT)",
      "Motivational Interviewing (MI)",
      "Trauma-Focused Therapy",
    ],
    whatToExpect: [
      "Initial assessment with a clinical psychologist",
      "Agreeing on goals for therapy together",
      "Evidence-based methods such as CBT and MI",
      "Practical coping skills you can use daily",
      "Regular review of progress",
      "Complete confidentiality at every step",
    ],
    coreValues: {
      title: "Our Core Values",
      desc: "Empowering individuals through empathy, trust, and professional psychological care.",
    },
    features: [
      {
        icon: "icon-heart",
        title: "Individual Counseling",
        desc: "One-on-one therapy sessions tailored to personal needs.",
      },
      {
        icon: "icon-doctor",
        title: "Group Therapy",
        desc: "Therapeutic group sessions for shared healing.",
      },
      {
        icon: "icon-call3",
        title: "Crisis Counseling",
        desc: "Immediate psychological support during emotional crises.",
      },
      {
        icon: "icon-drugs",
        title: "Behavioral Therapy",
        desc: "Evidence-based approaches for lasting behavioral change.",
      },
    ],
    relatedServiceIds: [1, 5, 6],
    order: 3,
  },
  {
    id: 4,
    slug: "inpatient-and-residential-treatment-care",
    icon: "icon-dropper",
    img: "/assets/images/services/4.jpg",
    title: "Inpatient & Residential Treatment Care",
    shortDesc: "Safe, secure residential care with 24/7 medical supervision and a structured daily programme.",
    desc: "Inpatient and residential treatment programs are designed for patients requiring continuous medical supervision and a structured therapeutic environment.",
    video: "https://www.youtube.com/watch?v=nrJtHemSPW4",
    duration: "Admission based on clinical need · Minimum 15 days",
    conditions: [
      "24/7 Medical & Nursing Supervision",
      "Secure & Confidential Accommodation",
      "Separate Units for Psychiatric & Addiction Care",
    ],
    whatToExpect: [
      "Admission assessment by the duty psychiatrist",
      "Separate, secure units for patients",
      "24/7 nursing and attendant supervision",
      "Structured daily routine and therapy",
      "Regular family updates and meetings",
      "Discharge planning and follow-up",
    ],
    coreValues: {
      title: "Our Core Values",
      desc: "Safety, structure, and compassionate care in a healing environment.",
    },
    features: [
      {
        icon: "icon-heart",
        title: "Residential Care",
        desc: "Comfortable and secure inpatient facilities.",
      },
      {
        icon: "icon-doctor",
        title: "Medical Supervision",
        desc: "Continuous monitoring by healthcare professionals.",
      },
      {
        icon: "icon-call3",
        title: "Emergency Response",
        desc: "Immediate intervention when needed.",
      },
      {
        icon: "icon-drugs",
        title: "Integrated Treatment",
        desc: "Combined psychiatric and addiction treatment plans.",
      },
    ],
    relatedServiceIds: [1, 2, 6],
    order: 4,
  },
  {
    id: 5,
    slug: "family-counseling-and-support-services",
    icon: "icon-heart3",
    img: "/assets/images/services/5.jpg",
    title: "Family Counseling & Support Services",
    shortDesc: "Helping families understand the illness, rebuild trust and become a strong part of recovery.",
    desc: "Family counseling helps families understand mental illness and addiction while strengthening communication, trust, and recovery support systems.",
    video: "https://www.youtube.com/watch?v=nrJtHemSPW4",
    duration: "Session: 60 minutes · Weekly or as advised",
    conditions: [
      "Family Education Programs",
      "Improved Family Communication",
      "Emotional Support for Caregivers",
    ],
    whatToExpect: [
      "Understanding the illness or addiction",
      "Improving communication at home",
      "Setting healthy boundaries",
      "Managing crisis situations",
      "Caregiver stress and self-care support",
      "Planning support after discharge",
    ],
    coreValues: {
      title: "Our Core Values",
      desc: "Strengthening families as a vital part of recovery.",
    },
    features: [
      {
        icon: "icon-heart",
        title: "Family Therapy",
        desc: "Guided therapy sessions involving family members.",
      },
      {
        icon: "icon-doctor",
        title: "Caregiver Support",
        desc: "Emotional and educational support for caregivers.",
      },
      {
        icon: "icon-call3",
        title: "Crisis Assistance",
        desc: "Support during family-related emergencies.",
      },
      {
        icon: "icon-drugs",
        title: "Education Programs",
        desc: "Workshops on mental health and addiction awareness.",
      },
    ],
    relatedServiceIds: [2, 3, 4],
    order: 5,
  },
  {
    id: 6,
    slug: "holistic-and-wellness-therapy-care",
    icon: "icon-heart2",
    img: "/assets/images/services/6.jpg",
    title: "Holistic & Wellness Therapy Care",
    shortDesc: "Yoga, meditation, fitness, nutrition and spiritual care alongside medical treatment.",
    desc: "Unity Health Centre integrates holistic therapies to address physical, emotional, and spiritual well-being alongside medical treatment.",
    video: "https://www.youtube.com/watch?v=nrJtHemSPW4",
    duration: "Part of daily inpatient programme",
    conditions: [
      "Yoga & Meditation",
      "Physical Fitness & Exercise Training",
      "Relaxation & Mindfulness Therapy",
      "Nutritional Wellness Programs",
    ],
    whatToExpect: [
      "Morning exercise and yoga",
      "Guided meditation and mindfulness",
      "Balanced, nutritious meals",
      "Recreational and creative activities",
      "Religious and motivational sessions",
      "Healthy daily routine building",
    ],
    coreValues: {
      title: "Our Core Values",
      desc: "Healing the mind, body, and spirit through holistic care.",
    },
    features: [
      {
        icon: "icon-heart",
        title: "Mindfulness Therapy",
        desc: "Stress reduction through guided mindfulness practices.",
      },
      {
        icon: "icon-doctor",
        title: "Wellness Coaching",
        desc: "Personalized lifestyle and wellness guidance.",
      },
      {
        icon: "icon-call3",
        title: "Support Sessions",
        desc: "Ongoing support to maintain holistic well-being.",
      },
      {
        icon: "icon-drugs",
        title: "Integrated Care",
        desc: "Holistic therapies combined with medical treatment.",
      },
    ],
    relatedServiceIds: [3, 4, 2],
    order: 6,
  },
];

export default services;
